import { useId } from 'react';

import { GRADIENTS, ICON_PATH } from '../Constants/Logo.constants';
import type { LogoProps } from '../Logo.types';

import styles from '../Styles/Default.module.css';

export function LogoGradient({
  fontSize = 40,
  ariaHidden = true,
  title,
  ariaLabel,
  role,
  dataTestId,
}: Omit<LogoProps, 'usage' | 'variant' | 'color'>) {
  const uid = useId();
  const clip = `${uid}c`;
  const gid = (n: number) => `${uid}g${n}`;

  return (
    <svg
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={styles.logo}
      data-test-id={dataTestId}
      role={role}
      style={{ fontSize }}
      viewBox="0 0 44 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <defs>
        <clipPath id={clip}>
          <path d={ICON_PATH} />
        </clipPath>
        {GRADIENTS.map(({ transform, stops, noR }, i) => (
          <radialGradient
            key={i}
            id={gid(i)}
            gradientUnits="userSpaceOnUse"
            gradientTransform={transform}
            {...(noR ? {} : { cx: '0', cy: '0', r: '1' })}
          >
            {stops.map((s, j) => (
              <stop key={j} {...s} />
            ))}
          </radialGradient>
        ))}
      </defs>
      <g clipPath={`url(#${clip})`}>
        {GRADIENTS.map(({ fillOpacity }, i) => (
          <rect
            key={i}
            x="0.12"
            y="0"
            width="43"
            height="39"
            fill={`url(#${gid(i)})`}
            fillOpacity={fillOpacity}
          />
        ))}
      </g>
    </svg>
  );
}
